import type { Provider } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { CachedTranslateLoader } from './cached-translate-loader';
import {
  CACHED_TRANSLATE_LOADER_CONFIG,
  type CachedTranslateLoaderConfig,
} from './translate-loader-config';

export function provideCachedTranslateLoader(
  config: CachedTranslateLoaderConfig = {},
): Provider[] {
  return [
    { provide: CACHED_TRANSLATE_LOADER_CONFIG, useValue: config },
    { provide: TranslateLoader, useClass: CachedTranslateLoader },
  ];
}
